export interface LoginCredentials {
  login: string;
  password: string;
}

export interface ImpersonatorInfo {
  adminId: number;
  adminUsername: string;
  adminFullName: string;
  adminToken: string;
}

/** Сотрудник точки (подчинённая учётка «Аптеки» или «Склада»): чья он и как заведён */
export interface StaffSessionInfo {
  kind: 'person' | 'shared' | null;
  masterId: number;
  masterLogin: string;
  masterName: string;
}

export interface AuthResponse {
  success: boolean;
  sessionToken?: string;
  deviceInfo?: string;
  userId: string | number;
  role: string;
  username: string;
  fullName?: string;
  guid?: string;
  belongsStorage?: string;
  cityId?: string;
  pharmacyNum?: string | number;
  lastPassUpd?: string | null;
  message?: string;
  versionMismatch?: boolean;
  isImpersonated?: boolean;
  impersonator?: ImpersonatorInfo;
  sessionWarning?: string;
  targetInterface?: 'admin' | 'dashboard';
  startPage?: string;
  roleLevel?: number;
  roleName?: string;
  permissions?: Record<string, any>;
  badge?: { bg: string; text: string; border: string };
  // У сотрудника точки username и role - точки (на них работает кабинет), свой логин - staffLogin
  staffLogin?: string;
  staff?: StaffSessionInfo;
}

export interface UserSession {
  id: number;
  sessionToken: string;
  ipAddress: string;
  deviceInfo: string;
  currentSection: string;
  lastActivityAt: string;
  createdAt: string;
  revokedAt?: string | null;
  revokedReason?: string | null;
  isOnline: boolean;
  isRevoked?: boolean;
  impersonatedBy?: number | null;
}

export type ServerStatus = 'connected' | 'error' | 'checking';

export interface AuthHookResult {
  loading: boolean;
  error: string | null;
  handleLogin: (credentials: LoginCredentials, rememberMe: boolean) => Promise<{ success: boolean; error?: string; requiresPasswordChange?: boolean; versionMismatch?: boolean }>;
  clearError: () => void;
  requiresPasswordChange: boolean;
  pendingLoginData: any;
  onPasswordChangeComplete: () => void;
}

export interface ServerStatusHookResult {
  serverStatus: ServerStatus;
  checkServerStatus: () => Promise<void>;
}

// Re-export password reset types
export * from './passwordResetTypes';